var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"messageFrame",style:({ minWidth: '100%', width: '1px', height: _vm.iframeHeight + 'px' }),attrs:{"frameborder":"0","src":_vm.src},on:{"error":_vm.handleIframeError,"load":_vm.onIframeLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }